import React, {Component} from 'react';
import ModalOverlay from "../components/ModalOverlay/ModalOverlay";
import Modal from "../components/Modal/Modal";
import ApiResponse from "../components/ApiResponse/ApiResponse";
import {connect} from "react-redux";
import * as actions from "../actions/ApiActions";

class ApiUIHandler extends Component {

    constructor(props) {
        super(props);

        this.closeModal = this.closeModal.bind(this);
    }

    closeModal() {
        const {resetApiResponse} = this.props;

        resetApiResponse({
                error: false,
                message: ""
            });
    }

    render() {
        const {apiResponse} = this.props;

        return (
            <div>
                <ModalOverlay visible={(apiResponse.message !== "")}/>

                <Modal visible={(apiResponse.message !== "")} closeAction={() => this.closeModal()}>

                    <ApiResponse response={apiResponse} />

                </Modal>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        apiResponse: state.apiResponse
    };
}

export default connect(mapStateToProps, actions)(ApiUIHandler);



// WEBPACK FOOTER //
// ./src/container/ApiUIHandler.js